import React, { useState, useEffect } from "react";
import Pageloader from "../../../components/loader";
import {Table, Button, Typography, Space, Tooltip} from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { dataKey } from "../../../utils/Helpers";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import CancellationsReasonsDeleteModal from "./deleteModal";
import * as actionPage from "../../../redux/actions/cancellationReason.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const { Title } = Typography;

const pageName = "Cancellations Reasons";
const pageLink = "cancellationsreasons";

const CancellationsReasonsList = (props) => {
  const navigate = useNavigate();
  const [noteListItems, setNoteListItems] = useState(null);
  const [loading, setLoading] = useState(false);
 
  useEffect(() => {
    dispacthNoteList()
  }, [])

  const dispacthNoteList = async () => {
    try {
      setLoading(true);
      await props.actionPage.cancellationReasonListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    if (props.pageData){
      setNoteListItems(dataKey(props.pageData))
    }
  }, [props.pageData])


  const columns = [
    {
      title: 'Id',
      dataIndex: 'display_id',
    },
    {
      title: 'Note',
      dataIndex: 'value',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      render: (value)=>{return <><span>{moment(value).format("DD MMMM, yyyy")}</span><p>{moment(value).format("h:mm A")}</p></>},
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      render: (value)=>{return <><span>{moment(value).format("DD MMMM, yyyy")}</span><p>{moment(value).format("h:mm A")}</p></>},
    },
    {
      title: 'Action',
      render: (value)=>{
      return <Space>
        <Tooltip title="Edit">
          <EditOutlined onClick={() => navigate(`/${pageLink}/edit/${value._id}`)} />
        </Tooltip>
        <Tooltip title="Delete">
          <DeleteOutlined onClick={() => handleModalOpen(value._id, value.display_id, value.value)} />
        </Tooltip>
      </Space>},
    },
  ]

  const [notesModal, setNotesModal] = useState({
    visible: false,
    postid: null,
    displayid: null,
    value: null,
  });

  const handleModalOpen = (id, dId, val) => {
    setNotesModal((notesModal) => ({
      ...notesModal,
      visible: true,
      postid: id,
      displayid: dId,
      value: val,
    }));
  };
  const handleModalCancel = () => {
    setNotesModal((notesModal) => ({
      ...notesModal,
      visible: false,
      postid: null,
      displayid: null,
      value: null,
    }));
  };

  return (
    <div className="page-content">
      <CancellationsReasonsDeleteModal
        handlevisible={notesModal.visible}
        handleCancel={handleModalCancel}
        refreshData={dispacthNoteList}
        postdata={notesModal}
      />
      <div className="page-content-header">
        <Title level={2}>{pageName}s Management</Title>
        <div>
          <Button onClick={() => navigate(`/${pageLink}/add`)}>{pageName} Add</Button>
        </div>
      </div>
      {loading ? (
        <Pageloader />
      ) : (
        <Table dataSource={noteListItems} columns={columns} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pageData: state.CancellationReasonReducer?.initialData,
    pagePagination: state.CancellationReasonReducer?.initialPagination,
    pageLoading: state.CancellationReasonReducer?.initialLoading,
    pageFilter: state.CancellationReasonReducer?.initialFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CancellationsReasonsList);
